/* global swal angular */
import './style.less';
import { assign } from 'lodash';

export default function($log, $state, $stateParams, Swal, ApiClass, ProfileClass, ResolveClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;

  vm.loggedIn = ProfileClass.loggedIn;

  let profile_uid;

  const manage = ResolveClass.isManageRoute();

  vm.answerData = {
    radio: [],
    input: [],
    text_area: [],
    checkbox: [],
    instructors: []
  };

  vm.submit = answers => {
    const id = vm.eventInfo.event_id;
    const eventType = vm.eventInfo.type;

    const review = {
      course_id: vm.eventInfo.course_id,
      event_id: vm.eventInfo.event_id,
      form_id: vm.eventInfo.form_id,
      profile_uid,
      ...answers
    };

    vm.submitBtn = true;

    return ApiClass.eventsIdTypePut({ id, type: 'reviews' }, { review, eventType })
      .then(() => {
        _toast('Evaluation has been submitted');
        vm.submitBtn = false;
        if (profile_uid) return $state.go('app.users.dashboard', { id: profile_uid });

        $state.go('app.register');
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function navigate() {
    if (!profile_uid) {
      return $state.go('app.login');
    }

    $state.go('app.users.dashboard', { id: profile_uid });
  }

  function handleError() {
    Swal.alert('Hold Up!', 'Please complete the course before evaluating.', 'info')
      .then(() => navigate())
      .catch(error => {
        navigate();
        $log.error(error);
        throw error;
      });
  }

  function _toast(message) {
    Swal.toast(message, 'info');
  }

  function activate() {
    profile_uid = vm.profileUid || (ProfileClass.profileComplete.profile || {}).profile_uid || null;

    ApiClass.eventsIdTypeTypeIdGet(
      { id: vm.eventId || $stateParams.id, type: 'reviews', type_id: profile_uid },
      {},
      { queryParams: { manage } }
    )
      .then(result => {
        const {
          data: { event }
        } = result;
        const {
          evaluation,
          evaluationForm,
          instructors,
          sponsor: { logoUrl }
        } = event;

        if (!event.evaluationForm) {
          return handleError();
        }

        const instructorTemplate = {
          radio: [],
          input: [],
          text_area: [],
          checkbox: []
        };

        if (evaluationForm.instructors && instructors) {
          instructors.forEach(() => vm.answerData.instructors.push(angular.copy(instructorTemplate)));
        }

        if (evaluation) {
          vm.answerData = assign(vm.answerData, evaluation);
        }

        try {
          event.logo = logoUrl;
        } catch (error) {
          $log.error(error);
        }

        vm.eventInfo = event;
        vm.formData = evaluationForm;
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/eventEvaluation/controller.js